import { render, staticRenderFns } from "./LicencaSelectModal.vue?vue&type=template&id=85cc431e&scoped=true"
import script from "./LicencaSelectModal.vue?vue&type=script&lang=js"
export * from "./LicencaSelectModal.vue?vue&type=script&lang=js"
import style0 from "./LicencaSelectModal.vue?vue&type=style&index=0&id=85cc431e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85cc431e",
  null
  
)

export default component.exports